import { useMemo } from 'react';
import { settingsServiceParser } from 'common/settingsService/impl/cache/settingsServiceParser';
import { SettingsServiceTypes } from 'common/settingsService/types';
import { SETTINGS_SERVICE_CONTEXT } from 'common/settingsService/impl/contextName';
import { useLocalStorage } from '@utmost.co/utmost-design-system/src/hooks/useLocalStorage';

export function useSettingsServiceCache() {
  const [state, setState] = useLocalStorage(SETTINGS_SERVICE_CONTEXT);
  const result = useMemo(
    () => ({
      getCache() {
        return settingsServiceParser.parse(state ?? '{}');
      },
      getRawCache() {
        return state;
      },
      setCache(value: SettingsServiceTypes.StateModel) {
        setState(settingsServiceParser.stringify(value ?? {}));
      },
      setRawCache(value: string) {
        setState(value);
      }
    }),
    [setState, state]
  );

  return result;
}
